// import { Html5QrcodeScanner, Html5QrcodeScanType } from 'html5-qrcode';
// import { Camera, Edit3, Scan, X } from 'lucide-react';
// import { useEffect, useRef, useState } from 'react';
// import { showErrorToast, showSuccessToast } from '../utils';

// interface BarcodeInputProps {
//   disabled: boolean;
// }

// export const BarcodeInput = ({ disabled }: BarcodeInputProps) => {
//   const [value, setValue] = useState('');
//   const [showScanner, setShowScanner] = useState(false);
//   const [manualMode, setManualMode] = useState(false);
//   const scannerRef = useRef<HTMLDivElement>(null);
//   const html5QrcodeScannerRef = useRef<Html5QrcodeScanner | null>(null);

//   useEffect(() => {
//     if (showScanner && scannerRef.current && !html5QrcodeScannerRef.current) {
//       html5QrcodeScannerRef.current = new Html5QrcodeScanner(
//         'qr-reader',
//         {
//           fps: 10,
//           qrbox: { width: 250, height: 250 },
//           supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
//         },
//         false,
//       );

//       html5QrcodeScannerRef.current.render(
//         (decodedText) => {
//           setValue(decodedText);
//           setShowScanner(false);
//           showSuccessToast('Code scanned successfully!');
//           if (html5QrcodeScannerRef.current) {
//             html5QrcodeScannerRef.current.clear().catch(console.error);
//             html5QrcodeScannerRef.current = null;
//           }
//         },
//         (error) => {
//           console.debug('Scan error:', error);
//         },
//       );
//     }

//     return () => {
//       if (html5QrcodeScannerRef.current) {
//         html5QrcodeScannerRef.current.clear().catch(console.error);
//         html5QrcodeScannerRef.current = null;
//       }
//     };
//   }, [showScanner]);

//   const handleScanClick = async () => {
//     try {
//       setShowScanner(true);
//     } catch {
//       showErrorToast('Camera access denied. Please allow camera access to scan codes.');
//     }
//   };

//   const closeScanner = () => {
//     if (html5QrcodeScannerRef.current) {
//       html5QrcodeScannerRef.current.clear().catch(console.error);
//       html5QrcodeScannerRef.current = null;
//     }
//     setShowScanner(false);
//   };

//   return (
//     <div className="space-y-3">
//       {/* Input with scan button */}
//       <div className="flex gap-2">
//         <input
//           type="text"
//           value={value}
//           onChange={(e) => setValue(e.target.value)}
//           placeholder="Scan or enter barcode/QR code…"
//           className="w-full border border-[#C0275E] rounded-lg p-2 text-sm text-[#621C43] bg-[#F8EFF3] focus:outline-none focus:ring-2 focus:ring-[#C0275E]/50 flex-1"
//           disabled={disabled}
//         />
//         {!disabled && (
//           <button
//             type="button"
//             onClick={handleScanClick}
//             className="flex items-center gap-1 px-3 py-1.5 bg-[#C0275E] text-white rounded-lg text-sm hover:bg-[#a01f4e] transition-colors"
//           >
//             <Scan size={16} />
//           </button>
//         )}
//       </div>

//       {/* Mode toggle */}
//       <div className="flex gap-2">
//         <button
//           type="button"
//           onClick={() => setManualMode(false)}
//           className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-xs font-medium transition-colors ${
//             !manualMode
//               ? 'bg-[#C0275E] text-white'
//               : 'bg-[#F8EFF3] text-[#621C43] border border-[#C0275E]'
//           }`}
//           disabled={disabled}
//         >
//           <Camera size={14} />
//           Camera Scan
//         </button>
//         <button
//           type="button"
//           onClick={() => setManualMode(true)}
//           className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-xs font-medium transition-colors ${
//             manualMode
//               ? 'bg-[#C0275E] text-white'
//               : 'bg-[#F8EFF3] text-[#621C43] border border-[#C0275E]'
//           }`}
//           disabled={disabled}
//         >
//           <Edit3 size={14} />
//           Manual Entry
//         </button>
//       </div>

//       {/* Scanner */}
//       {showScanner && (
//         <div className="relative border border-[#C0275E] rounded-lg overflow-hidden">
//           <button
//             type="button"
//             onClick={closeScanner}
//             className="absolute top-2 right-2 z-10 p-1 bg-white rounded-full shadow-md hover:bg-gray-100"
//           >
//             <X size={16} />
//           </button>
//           <div id="qr-reader" ref={scannerRef} className="w-full" />
//         </div>
//       )}

//       {/* Manual entry hint */}
//       {manualMode && !showScanner && (
//         <p className="text-xs text-gray-400">Type the barcode or QR code value above</p>
//       )}
//     </div>
//   );
// };

import { Html5QrcodeScanner, Html5QrcodeScanType } from 'html5-qrcode';
import { Camera, Edit3, Scan, X } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { showErrorToast, showSuccessToast } from '../utils';

interface BarcodeInputProps {
  disabled: boolean;
}

export const BarcodeInput = ({ disabled }: BarcodeInputProps) => {
  const [value, setValue] = useState('');
  const [showScanner, setShowScanner] = useState(false);
  const [manualMode, setManualMode] = useState(false);
  const scannerRef = useRef<HTMLDivElement>(null);
  const html5QrcodeScannerRef = useRef<Html5QrcodeScanner | null>(null);

  useEffect(() => {
    if (showScanner && scannerRef.current && !html5QrcodeScannerRef.current) {
      html5QrcodeScannerRef.current = new Html5QrcodeScanner(
        'qr-reader',
        {
          fps: 10,
          qrbox: { width: 250, height: 250 },
          supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
        },
        false,
      );

      html5QrcodeScannerRef.current.render(
        (decodedText) => {
          setValue(decodedText);
          setShowScanner(false);
          showSuccessToast('Code scanned successfully!');
          if (html5QrcodeScannerRef.current) {
            html5QrcodeScannerRef.current.clear().catch(console.error);
            html5QrcodeScannerRef.current = null;
          }
        },
        (error) => {
          console.debug('Scan error:', error);
        },
      );
    }

    return () => {
      if (html5QrcodeScannerRef.current) {
        html5QrcodeScannerRef.current.clear().catch(console.error);
        html5QrcodeScannerRef.current = null;
      }
    };
  }, [showScanner]);

  const handleScanClick = async () => {
    try {
      setShowScanner(true);
    } catch {
      showErrorToast('Camera access denied. Please allow camera access to scan codes.');
    }
  };

  const closeScanner = () => {
    if (html5QrcodeScannerRef.current) {
      html5QrcodeScannerRef.current.clear().catch(console.error);
      html5QrcodeScannerRef.current = null;
    }
    setShowScanner(false);
  };

  return (
    <div className="space-y-3">
      {/* Input with scan button */}
      <div className="flex gap-2">
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Scan or enter barcode/QR code…"
          className="w-full border border-[#C0275E] rounded-lg p-2 text-sm text-[#621C43] bg-[#F8EFF3] focus:outline-none focus:ring-2 focus:ring-[#C0275E]/50 flex-1"
          disabled={disabled}
        />
        {!disabled && (
          <button
            type="button"
            onClick={handleScanClick}
            className="flex items-center gap-1 px-3 py-1.5 bg-[#C0275E] text-white rounded-lg text-sm hover:bg-[#a01f4e] transition-colors"
          >
            <Scan size={16} />
          </button>
        )}
      </div>

      {/* Mode toggle */}
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => setManualMode(false)}
          className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-xs font-medium transition-colors ${
            !manualMode
              ? 'bg-[#C0275E] text-white'
              : 'bg-[#F8EFF3] text-[#621C43] border border-[#C0275E]'
          }`}
          disabled={disabled}
        >
          <Camera size={14} />
          Camera Scan
        </button>
        <button
          type="button"
          onClick={() => setManualMode(true)}
          className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-xs font-medium transition-colors ${
            manualMode
              ? 'bg-[#C0275E] text-white'
              : 'bg-[#F8EFF3] text-[#621C43] border border-[#C0275E]'
          }`}
          disabled={disabled}
        >
          <Edit3 size={14} />
          Manual Entry
        </button>
      </div>

      {/* Scanner */}
      {showScanner && (
        <div className="relative border border-[#C0275E] rounded-lg overflow-hidden">
          <button
            type="button"
            onClick={closeScanner}
            className="absolute top-2 right-2 z-10 p-1 bg-white rounded-full shadow-md hover:bg-gray-100"
          >
            <X size={16} />
          </button>
          <div id="qr-reader" ref={scannerRef} className="w-full" />
        </div>
      )}

      {/* Manual entry hint */}
      {manualMode && !showScanner && (
        <p className="text-xs text-gray-400">Type the barcode or QR code value above</p>
      )}
    </div>
  );
};
